module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "reset-pwd-success",
      "role": "dialog",
      "aria-labelledby": "myModalLabel"
    }
  }, [_c('div', {
    staticClass: "modal-dialog",
    attrs: {
      "role": "document",
      "aria-hidden": "true"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('span', {
    staticClass: "close",
    attrs: {
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('svg', {
    staticClass: "icon",
    attrs: {
      "aria-label": "true"
    }
  }, [_c('use', {
    attrs: {
      "xlink:href": "#icon-close"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_vm._m(0), _vm._v(" "), _c('p', {
    staticClass: "describe"
  }, [_vm._v(_vm._s(_vm.$t('successInfo')))])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    attrs: {
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_vm._v(_vm._s(_vm.$t('ok')))])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('img', {
    attrs: {
      "src": "/static/img/resetPwd/success.png",
      "alt": "重置密码成功"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-0e8c2375!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/resetPwdSuccessNotice/SuccessNotice.vue
// module id = 1262
// module chunks = 1